import { ApolloLink } from "@apollo/client";
import { AppConfig } from "@/infrastructure/services/config";

const _appConfig = AppConfig.getInstance();
const TIMESTAMP = _appConfig.TIMESTAMP;
const TIMEZONE = _appConfig.TIMEZONE;

export const graphQlVariablesLink = new ApolloLink((operation, forward) => {
  const defaultData = {
    timestamp: TIMESTAMP,
    timezone: TIMEZONE,
  };

  operation.variables = {
    ...operation.variables, // Preserve existing variables
    ...defaultData,
  };

  return forward(operation);
});
